module.exports = __webpack_public_path__ + "static/media/Dependent cameras_2.71b835a3.png";